<template>
    <div class="field-favicon">
        <app-filepicker
            label="Icon wählen"
            data-source="deha.user.misc.favicon"
            accept=".jpg,.png,.gif"
        ></app-filepicker>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import pushid from 'pushid';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {
            id: pushid()
        };
    },
    components: {
        'app-filepicker': Filepicker
    },
    methods: {},
    computed: {
        ...mapGetters(['getThemes', 'generateMediaUrl'])
    },
    mounted() {},
    mixins: [SimpleFieldMixin],
    props: {}
};
</script>
